module.exports = __webpack_public_path__ + "img/1448960284.fcdb523e.jpg";